import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
// SPESİYAL
import SayfaYok from './pages/spesiyal/SayfaYok'
import Yetkisiz from './pages/spesiyal/Yetkisiz'
// GİRİŞ
import GirisRoute from './pages/Giris/_route'
import GirisIndex from './pages/Giris/index'
import GirisHesap from './pages/Giris/hesap'
import GirisParola from './pages/Giris/parola'
import GirisSifirla from './pages/Giris/sifirla'
import GirisOnay from './pages/Giris/onay'
// PANEL
import Panel from './pages/Panel/index'

// SPESİYAL
import KullaniciRouter from './pages/Kullanici/_route'
import Kullanici from './pages/Kullanici/index'
import KullaniciDetay from './pages/Kullanici/detay'

// ÖZEL

import aidatimFatura from './pages/_a/Fatura'
import lazerFatura from './pages/_a/lazerFatura'


// ENERJİ
import aienerji from './pages/_Sayac/_route'
import aienerjiIndex from './pages/_Sayac/Bina/Index'
import aienerjiDetay from './pages/_Sayac/Bina/Detay'
import aienerjiDonem from './pages/_Sayac/Donem/Index'
import aienerjiDokum from './pages/_Sayac/Dokum/Index'
import aienerjiDokumDetay from './pages/_Sayac/Dokum/Detay'
import aienerjiAbone from './pages/_Sayac/Abone/Index'

// SAYAÇ
import aiEnerjiMuhasebeRouter from './pages/_Sayac/Muhasebe/Index'
import aiEnerjiMuhasebePanel from './pages/_Sayac/Muhasebe/_/Panel'
import aiEnerjiMuhasebeBinaListe from './pages/_Sayac/Muhasebe/_/BinaListe'
import aiEnerjiMuhasebeRapor from './pages/_Sayac/Muhasebe/_/Rapor'
import aiEnerjiMuhasebeFatura from './pages/_Sayac/Muhasebe/_/Fatura'


// JETUSTA
import juIndex from './pages/JetUsta/Index'


import Stok from './pages/Stok/Index'
import StokDetay from './pages/Stok/Detay'


import Pazarlama from './pages/Pazarlama/Index'

import Raporlama from './pages/Raporlama/_route'
import RaporlamaSayac from './pages/Raporlama/Sayac'
import RaporlamaBina from './pages/Raporlama/Bina'
import RaporlamaUzaktanOkuma from './pages/Raporlama/UzaktanOkuma'
import RaporlamaTelegram from "./pages/Raporlama/Telegram";
import RaporlamaTeknik from "./pages/Raporlama/Teknik";

Vue.use(VueRouter);

export const router = new VueRouter({
  routes: [
    {
      path: "/giris",
      component: GirisRoute,
      children: [
        {path: "", component: GirisIndex},
        {path: "hesap", component: GirisHesap},
        {path: "parola", component: GirisParola},
        {path: "sifirla/:SifirlamaKodu", component: GirisSifirla},
        {path: "onay", component: GirisOnay}
      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next("/panel");
        } else {
          next();

        }
      }
    },
    {
      path: "/",
      component: Panel,
    },
    {
      path: "/panel",
      component: Panel,
    },
    {
      path: "/jetusta", component: juIndex,
    },
    {
      path: "/raporlama", component: Raporlama,
      children: [
        {path: "", component: RaporlamaBina},
        {path: "bina", component: RaporlamaBina},
        {path: "sayac", component: RaporlamaSayac},
        {path: "uo", component: RaporlamaUzaktanOkuma},
        {path: "telegram", component: RaporlamaTelegram},
        {path: "teknik", component: RaporlamaTeknik},
        {path: "fatura", component: aidatimFatura},
        {path: "lazerfatura", component: lazerFatura},
      ]
    },
    {
      path: "/pazarlama", component: Pazarlama,
    },
    {
      path: "/stok", component: Stok,
      children: [
        {path: "", component: StokDetay, props: true},
        {path: ":Urun_id", component: StokDetay, props: true}
      ]
    },
    {
      path: "/jetusta", component: juIndex,
    },
    {
      path: "/", component: aienerji,
      children: [
        {path: "fatura", component: aidatimFatura},
        {path: "abone", component: aienerjiAbone},
        {path: "bina", component: aienerjiIndex},
        {path: "bina/:Bina_id", component: aienerjiDetay, props: true},
        {path: "donem", component: aienerjiDonem},
        {path: "dokum", component: aienerjiDokum},
        {path: "dokum/:Fatura_id", component: aienerjiDokumDetay, props: true},
        {
          path: "muhasebe", component: aiEnerjiMuhasebeRouter,
          children: [
            {path: "ekran", component: aiEnerjiMuhasebePanel},
            {path: "bina", component: aiEnerjiMuhasebeBinaListe},
            {path: "fatura", component: aidatimFatura},

            {path: "rapor", component: aiEnerjiMuhasebeRapor},
          ]
        },
      ]
    },
    {
      path: "/kullanici",
      component: KullaniciRouter,
      children: [
        {path: "", component: Kullanici},
        {path: ":Kullanici_id", component: KullaniciDetay, props: true}
      ],
    },
    {
      path: "",
      component: Panel,
    },
    {
      path: "/403",
      component: Yetkisiz,
    },
    {
      path: "*",
      component: SayfaYok,
    }

  ],
  mode: "history"
});



// WEBPACK FOOTER //
// ./src/router.js